import { IProductProperties, IReactAdminProperties } from "../types";

/**
 * this utility is used to transform collected values from react admin array input form
 * to be sent to firestore
 * */
export const prepareProductProperties = (properties: IReactAdminProperties) => {
  return properties.reduce((properties, propertyEntry) => {
    return {
      ...properties,
      [propertyEntry.color]: {
        images: propertyEntry.images,
        sizes: propertyEntry.sizes.reduce((sizes, sizeEntry) => {
          return {
            ...sizes,
            [sizeEntry.size]: sizeEntry.quantity,
          };
        }, {}),
      },
    };
  }, {});
};

/**
 * this utility is used to transform firestore product properties
 * to match react admin array input form
 * */
export const prepareRAProperties = (properties: IProductProperties) => {
  return Object.entries(properties).map(([color, entry]) => {
    return {
      color,
      images: entry.images,
      sizes: Object.entries(entry.sizes).map(([size, quantity]) => {
        return {
          size,
          quantity,
        };
      }),
    };
  });
};

/**
 * calculate total quantity from react admin array input form array
 * */
export const getTotalProducts = (properties: IReactAdminProperties): number => {
  return properties.reduce((propertiesCount, propertyEntry) => {
    return (
      propertiesCount +
      propertyEntry.sizes.reduce((sizesCount, sizeEntry) => {
        return sizesCount + sizeEntry.quantity;
      }, 0)
    );
  }, 0);
};

/**
 * calculate total quantity from firestore object schema
 * */
export const getTotalProductsQuantity = (properties: IProductProperties): number => {
  return Object.values(properties).reduce((total: number, current: any) => {
    return (
      total +
      Object.values<any>(current.sizes).reduce((colorQuantity: number, sizeQuantity: number) => {
        return colorQuantity + sizeQuantity;
      }, 0)
    );
  }, 0);
};
